module.exports = __webpack_public_path__ + "img/missed_call_icon.d59f4638.svg";